import React from 'react';

import Button from 'CommonComponents/Button';

export default function ModalFooter({
    allowCancel = true,
    allowSubmit = true,
    allowDelete = false,
    cancelButtonFirst = true,
    primaryButtonDisabled = false,
    submitButtonVariant = 'danger',
    cancelButtonVariant = 'secondary',
    deleteButtonVariant = 'danger',
    startContent = null,
    ...props
}) {
    return (
        <div className="modal__footer tw-justify-between">
            {startContent}
            {allowDelete && (
                <Button variant={deleteButtonVariant} onClick={props.onDelete} disabled={props.isDeleting} className={'tw-self-start'}>
                    {props.deleteButtonText}
                </Button>
            )}
            <div className="tw-flex tw-w-full tw-space-x-1.5 tw-justify-end">
                {allowCancel && cancelButtonFirst && (
                    <Button variant={cancelButtonVariant} onClick={props.onCancel} disabled={props.isSubmitting}>
                        {props.cancelButtonText}
                    </Button>
                )}
                {allowSubmit && (
                    <Button variant={submitButtonVariant} onClick={props.handleSubmit} disabled={props.isSubmitting || primaryButtonDisabled}>
                        {props.primaryButtonText}
                    </Button>
                )}
                {allowCancel && !cancelButtonFirst && (
                    <Button variant={cancelButtonVariant} onClick={props.onCancel} disabled={props.isSubmitting}>
                        {props.cancelButtonText}
                    </Button>
                )}
            </div>
        </div>
    );
}
